(function () {
  function findNearbyHeading(el) {
    var container = el.closest(
      'section, .tab-pane, .video-reviews-item, .desk-parameters, .desky-product-tab, .desky-product-description, [class*="section"]'
    );
    if (!container) container = el.parentElement;
    if (!container) return null;

    var headings = container.querySelectorAll('h1, h2, h3, h4');
    var best = null;

    headings.forEach(function (heading) {
      if (heading.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) {
        best = heading;
      }
    });

    if (best) return best.textContent.replace(/\s+/g, ' ').trim();
    if (headings.length) return headings[0].textContent.replace(/\s+/g, ' ').trim();
    return null;
  }

  function getProductTitle() {
    var el = document.querySelector('h1.product__title, .product__info-container h1');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : null;
  }

  function humanizeFilename(src) {
    var match = src.match(/\/([^/?#]+)\.(gif|jpe?g|png|webp|svg)/i);
    if (!match) return null;
    return match[1].replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isEmbedIframe(iframe) {
    var src = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
    return /youtube\.com|youtube-nocookie\.com|vimeo\.com/i.test(src);
  }

  function needsTitle(iframe) {
    if (!iframe || iframe.tagName !== 'IFRAME' || !isEmbedIframe(iframe)) return false;
    if (iframe.title && iframe.title.trim()) return false;
    if (iframe.getAttribute('aria-label') && iframe.getAttribute('aria-label').trim()) return false;
    if (iframe.closest('[aria-hidden="true"]')) return false;
    return true;
  }

  function resolveIframeTitle(iframe) {
    var ariaLabel = iframe.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.trim()) return ariaLabel.trim();

    var heading = findNearbyHeading(iframe);
    if (heading) return heading;

    var productTitle = getProductTitle();
    if (productTitle) return productTitle + ' video';

    return /vimeo\.com/i.test(iframe.getAttribute('src') || iframe.getAttribute('data-src') || '')
      ? 'Vimeo video player'
      : 'YouTube video player';
  }

  function isDecorativeImage(img) {
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';

    if (img.getAttribute('role') === 'presentation' || img.getAttribute('aria-hidden') === 'true') {
      return true;
    }

    if (/spacer|divider|decoration|1x1|pixel\.|transparent\./i.test(src)) {
      return true;
    }

    if (
      img.closest('.desky-product-tab, .desky-product-description, .tab-pane') &&
      /\.gif(?:\?|$)/i.test(src)
    ) {
      return true;
    }

    return false;
  }

  function resolveImageAlt(img) {
    if (isDecorativeImage(img)) return '';

    var heading = findNearbyHeading(img);
    if (heading) return heading;

    var fromFile = humanizeFilename(img.getAttribute('src') || img.getAttribute('data-src') || '');
    if (fromFile) return fromFile;

    return '';
  }

  function fixIframeTitles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('iframe').forEach(function (iframe) {
      if (!needsTitle(iframe)) return;
      iframe.title = resolveIframeTitle(iframe);
    });
  }

  function fixImageAlts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img').forEach(function (img) {
      if (img.hasAttribute('alt') || img.closest('[aria-hidden="true"]')) return;
      img.setAttribute('alt', resolveImageAlt(img));
    });
  }

  function fixContentA11y(root) {
    fixIframeTitles(root);
    fixImageAlts(root);
  }

  function initContentA11y() {
    fixContentA11y(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          (mutation.target.tagName === 'IFRAME' || mutation.target.tagName === 'IMG')
        ) {
          fixContentA11y(mutation.target.parentElement || document);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IFRAME' || node.tagName === 'IMG') {
            fixContentA11y(node.parentElement || document);
          } else {
            fixContentA11y(node);
          }
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src', 'title', 'alt'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContentA11y);
  } else {
    initContentA11y();
  }
})();
